var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "content" }, [
      _c("h3", [_vm._v("列表数据")]),
      _c("div", { ref: "charts", staticClass: "proCharts" }),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", {
          ref: "totalSales",
          staticClass: "marketLimit",
          attrs: { id: "totalSales" },
        }),
        _c("div", {
          ref: "buyMoney",
          staticClass: "buyMoney",
          attrs: { id: "buyMoney" },
        }),
      ]),
      _c("div", {
        ref: "market",
        staticClass: "market",
        attrs: { id: "market" },
      }),
      _c("div", {
        ref: "staffData",
        staticClass: "staffData",
        attrs: { id: "staffData" },
      }),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", {
          ref: "clientData",
          staticClass: "clientData",
          attrs: { id: "clientData" },
        }),
        _c("div", {
          ref: "numberComparison",
          staticClass: "numberComparison",
          attrs: { id: "numberComparison" },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }